<template>
  <div class="offcn-teacher-open">
    <div class="create_content">
      <p class="create-title">中公直播</p>
      <p class="create-sectitle">直播间自助申请平台</p>
      <p class="create-thititle">第一步：请选择申请房间类型：</p>
      <p class="create-discri">1、大班课：用于人数较多的直播场景，听课人员可以通过【网页】和【H5】进入直播间。</p>
      <p class="create-discri">2、小班课：用于需要多人同时发言的直播场景，如视频会议。听课人员可以通过【桌面客户端】和【APP】进入直播间。</p>
      <p class="create-discri">直播间的使用手册：<a class="note" target="_blank" href="https://docs.qq.com/doc/DV0Z6UWVCcVhEVlNz">《中公直播使用手册》</a></p>
      <div class="create_button">
        <span @click="changetype(0)" :class="{'active': active}">申请大班课</span><span @click="changetype(1)" :class="{'active': isactive}">申请小班课</span>
        <p class="next_step" @click="showFlag = true">下一步</p>
      </div>
    </div>
    <div class="create_content" v-show="showFlag">
      <p class="create-title">中公直播</p>
      <p class="create-sectitle">直播间自助申请平台</p>
      <p class="create-opt">
        <span>mis口令码</span><input @keyup='check_able' class="mis_psd" type="text" v-model="input_text" maxlength="50" />
        <span class="error_msg" v-show='err_msg'>口令码错误,请确认重新输入</span>
      </p>
      <p class="create-opt">
        <span>房间名称</span><input @keyup='check_able' class="room_name" type="text" v-model="name_text" maxlength="50" />
      </p>
      <p class="create-opt">
        <span>直播时间</span>
        <input type="text" class="start" id="start_time"> &nbsp; -
        <input type="text" class="end" id="end_time"><span class="reload" @click='goback'>刷新</span><br>
        <span v-show='errFlag' class="error_msg">{{error_tip}}</span>
      </p>
      <p class="create_success">
        <button class="create_btn" @click='create_room' :disabled='!is_show' :class="{'create_bg':is_show}">立即申请</button>
      </p>
      <p class="create_intro">
        <a class="create_intro" target="_blank" href="https://docs.qq.com/doc/DV0Z6UWVCcVhEVlNz">《下载地址和使用手册》</a>
      </p>
    </div>
    <div class="create_room_msg" v-show="isshow">
      <p class="create-title">申请成功</p>
      <p class="create-ok">请提前安装客户端或APP，输入口令码登录直播间</p>
      <div class="create-password">
        <p>讲师口令:{{teacher_password}}</p>
        <p>助教口令:{{assistant_password}}</p>
        <p v-if="classtype == 0">学生网页听课地址：https://web.offcncloud.com?nickna<br/>me=&password={{student_password}}</p>
        <p v-else>学生口令:{{student_password}}</p>
        <p v-if="classtype == 0">回放地址：https://vod.offcncloud.com?account={{supervise_password}}</p>
        <p v-else>回放地址：https://pcvod.offcncloud.com/private/#/vod?account={{supervise_password}}</p>
        <p class="use_intro">请下载"中公直播客户端"</p>
        <p>下载地址：http://teacher.offcncloud.com/#/downloads</p>
        <p v-if="classtype == 0">使用说明:https://docs.qq.com/doc/DQ3BtbFJDS3NBRm9H</p>
        <p v-else>使用说明:https://docs.qq.com/doc/DV0Z6UWVCcVhEVlNz</p>
        <p class="create-copy" @click='copy'>一键复制</p>
        <input v-if="classtype == 0" class="copy-text" type="text" :value="'讲师口令:'+teacher_password+'助教口令:'+assistant_password+'学生网页听课地址：https://web.offcncloud.com?nickname=&password='+student_password+'&quot;中公直播客户端&quot;下载地址http://teacher.offcncloud.com/#/downloads使用说明:https://docs.qq.com/doc/DQ3BtbFJDS3NBRm9H回放地址：https://vod.offcncloud.com?account='+supervise_password">
        <input v-else class="copy-text" type="text" :value="'讲师口令:'+teacher_password+'助教口令:'+assistant_password+'学生口令:'+student_password+'请下载&quot;中公直播客户端&quot;下载地址http://teacher.offcncloud.com/#/downloads使用说明::https://docs.qq.com/doc/DV0Z6UWVCcVhEVlNz回放地址：https://pcvod.offcncloud.com/private/#/vod?account='+supervise_password">
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
// import md5 from 'js-md5'
export default {
  data () {
    return {
      showFlag: false,
      teacher_password: '',
      student_password: '',
      assistant_password: '',
      supervise_password: '',
      input_text: '',
      name_text: '',
      err_msg: false,
      global_url: '',
      error_tip: '',
      errFlag: false,
      is_show: false,
      active: false,
      isactive: false,
      classtype: 0,
      isshow: false
    }
  },
  methods: {
    create_room () {
      if (window.location.host === 'teacher.offcncloud.com') {
        this.global_url = '//live.offcncloud.com/api/'
      } else {
        this.global_url = '//test-live.offcncloud.com/api/'
      }
      if ($('.mis_psd').val().length !== 32) {
        this.err_msg = true
        return
      } else {
        this.err_msg = false
      }
      $.ajax({
        url: this.global_url + 'login',
        type: 'post',
        data: {
          username: 'wxy0001',
          password: '123123'
        },
        success: (res) => {
          $.ajax({
            url: this.global_url + 'room',
            type: 'post',
            headers: {
              Authorization: 'Bearer ' + res.data.access_token
            },
            data: {
              room_name: $('.room_name').val(),
              room_type: window.sessionStorage.getItem('type'),
              allow_recording: 1 // 生成回放
            },
            success: (req) => {
              let that = this
              that.teacher_password = req.data.teacher_password
              that.student_password = req.data.student_password
              that.assistant_password = req.data.assistant_password
              that.supervise_password = req.data.supervise_password
              $.ajax({
                url: this.global_url + 'room/' + req.data.room_num,
                type: 'put',
                headers: {
                  Authorization: 'Bearer ' + res.data.access_token
                },
                data: {
                  room_name: $('.room_name').val(),
                  start_time: $('.start').val(),
                  end_time: $('.end').val(),
                  province: '全国',
                  city: '全国',
                  area: '全国',
                  office_type: 1
                },
                success: (rez) => {
                  if (rez.code === 200) {
                    this.isshow = true
                  } else {
                    console.log(rez.data)
                    this.errFlag = true
                    this.error_tip = rez.msg
                  }
                }
              })
            }
          })
        }
      })
    },
    goback () {
      location.reload()
    },
    copy () {
      $('.copy-text').select()
      document.execCommand('Copy')
      alert('复制成功')
    },
    check_able () {
      if (this.input_text && this.name_text) {
        this.is_show = true
      } else {
        this.is_show = false
      }
    },
    changetype (type) {
      if (type === 0) {
        this.active = true
        this.isactive = false
        window.sessionStorage.setItem('type', 0)
      } else {
        this.active = false
        this.isactive = true
        window.sessionStorage.setItem('type', 1)
        this.classtype = window.sessionStorage.getItem('type')
      }
    }
  },
  mounted () {
    let startDate = laydate.render({// eslint-disable-line
      elem: '#start_time',
      type: 'datetime',
      min: new Date().getTime()
    })
    let endDate = laydate.render({// eslint-disable-line
      elem: '#end_time',
      type: 'datetime',
      min: new Date().getTime()
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.offcn-teacher-open
{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: url('timg.jpg');
  background-size: 100% 100%;
}
.create_content,.create_room_msg
{
  position: absolute;
  width: 655px;
  height: 414px;
  top: 50%;
  left: 50%;
  background: #ffffff;
  transform: translate(-50%, -50%);
}
.create-title
{
	text-align: center;
	padding-top: 20px;
	font-size: 28px;
	font-weight: 600;
  margin-bottom: 10px;
}
.create-sectitle
{
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
.create-thititle {
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  margin-left: 50px;
}
.create-discri {
  width: 558px;
  line-height: 20px;
  font-size: 14px;
  text-align: left;
  margin: 0 auto;
  margin-top: 10px;
}
.create_button {
  text-align: center;
  margin-top: 50px;
}
.create_button span {
  padding: 10px;
  border: 1px solid #cccccc;
  cursor: pointer;
}
.create_button span:first-child {
  margin-right: 20px;
}
.next_step {
  width: 90px;
  color: #ffffff;
  background: #00AAFF;
  margin: 0 auto;
  padding: 10px;
  margin-top: 30px;
  cursor: pointer;
}
.active {
  border: 2px solid blue!important;
}
.create-opt
{
  margin-left: 80px;
	line-height: 50px;
  position: relative;
}
.create-opt span
{
  display: inline-block;
  width: 80px;
}
input
{
  width: 330px;
  height: 25px;
  border-radius: 4px;
  margin-left: 10px;
  border: 1px solid;
  outline: none;
}
select
{
  width: 80px;
  margin-left: 5px;
}
.start,.end
{
  width: 150px;
  height: 22px;
  padding: 2px 0;
  font-size: 16px;
  line-height: 16px;
  margin-left: 6px;
  border: 1px solid;
  outline: none;
}
.create_success{
  text-align: center;
  margin-top: 20px;
  margin-bottom: 40px;
}
.create_btn
{
  padding: 11px 50px;
  border-width: 0;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  background: #009688;
  opacity: .3;
  color: #000000;
}
.create_bg
{
  color: #ffffff;
  background: #009688;
  opacity: 1;
}
.create_btns
{
  background: #009688;
  color: #ffffff;
  opacity: 1;
}
.use_intro
{
  margin-top: 10px;
}
.create_intro
{
	color: #0000ff;
  text-align: center;
  text-decoration: underline;
}
.create-password
{
  width: 525px;
  height: 260px;
  background: lightgrey;
  margin: 0 auto;
  margin-top: 20px;
  padding-top: 15px;
  line-height: 24px;
}
.create-password p
{
  margin-left: 20px;
}
.create-ok
{
  padding-top: 5px;
  text-align: center;
  margin-bottom: 20px;
  font-weight: bold;
}
.copy-text
{
  opacity: 0;
}
.create-copy
{
  color: #009688;
  text-decoration: underline;
  margin-top: 20px;
  margin-right: 20px;
  cursor: pointer;
  font-size: 18px;
}
.error_msg{
  color: red;
  font-size: 12px;
  position: absolute;
  line-height: 12px;
  top: 42px;
  left: 90px;
  width: 197px!important;
}
.reload
{
  margin-left: 15px;
  cursor: pointer;
}
.note {
  color: #000000;
  text-decoration: underline;
}
@media screen and (max-width: 414px) {
  .create_content,.create_room_msg
  {
    width: 320px;
    height: 464px;
  }
  .create-opt
  {
    margin-left: 0;
  }
  input
  {
    width: 224px;
  }
  .start,.end
  {
    width: 214px;
  }
  .create-password
  {
    width: 315px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/offcn-teacher-create/create.vue